import { NineButton, NineHeading } from "@9amhealth/wcl/generated/react";
import { FC } from "react";
import Translate from "src/ui/components/Translate/Translate";
import { ChatUploadLabResultsCubit } from "../ChatUploadLabResultsCubit";
import { useBlocNext } from "@blac/react";
import { PlanIneligibleIcon } from "src/constants/icons";
import {
  HelpLinkButton,
  HelpLinkWrap,
  InfoText,
  StepContent,
  SupportActions
} from "../components";

export const UnsupportedFormatScreen: FC = () => {
  const [, { setCurrentStep }] = useBlocNext(ChatUploadLabResultsCubit);

  const handleBackToUpload = () => {
    setCurrentStep("upload");
  };

  const handleSeeHowWeCanHelp = () => {
    setCurrentStep("providerSelection");
  };

  return (
    <StepContent>
      <NineHeading>
        <PlanIneligibleIcon />
        <h3 className="as-h4-large">
          <Translate msg="chat.labUpload.unsupportedFormat.title" />
        </h3>
      </NineHeading>
      <InfoText>
        <Translate msg="chat.labUpload.unsupportedFormat.description" />
      </InfoText>
      <SupportActions>
        <NineButton onClick={handleBackToUpload}>
          <Translate msg="chat.labUpload.unsupportedFormat.back" />
        </NineButton>
      </SupportActions>
      <HelpLinkWrap>
        <div>
          <Translate msg="chat.labUpload.unsupportedFormat.missingReport" />
        </div>
        <HelpLinkButton type="button" onClick={handleSeeHowWeCanHelp}>
          <Translate msg="chat.labUpload.unsupportedFormat.howWeCanHelp" />
        </HelpLinkButton>
      </HelpLinkWrap>
    </StepContent>
  );
};
